import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class VersionCheckService {

    private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';
    private messageDisplayed = false;

    constructor(private http: HttpClient,
                private toastrService: ToastrService,
                private translate: TranslateService) {
        this.setupChunkErrorListener();
    }

    private setupChunkErrorListener() {
        window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
            const error = event.reason;
            const errorMessage = error?.message || error?.toString() || '';
            if (errorMessage.includes('Failed to fetch dynamically imported module') ||
                errorMessage.includes('Loading chunk') ||
                errorMessage.includes('ChunkLoadError') ||
                (errorMessage.includes('.js') && errorMessage.includes('Failed to fetch'))) {
                this.forceShowUpdateMessage();
            }
        });
    }

    public initVersionCheck(url, frequency = 1000 * 60 * 30) {
        setInterval(() => {
            this.checkVersion(url);
        }, frequency);
        this.checkVersion(url);
    }

    public forceShowUpdateMessage() {
        if (!this.messageDisplayed) {
            this.messageDisplayed = true;
            this.showUpdateMessage(true);
        }
    }

    private showUpdateMessage(hasError: boolean = false) {
        let message = '<div class="small">' + this.translate.instant('O Food Checker foi atualizado para uma nova versão! É necessário atualizar a página. Deseja fazer isso agora?');

        if (hasError) {
            message += '<div class="text-danger small mt-2"><strong>' + this.translate.instant('⚠ Atenção:') + '</strong> ' + this.translate.instant('Enquanto não atualizar, podem ocorrer erros ao carregar funcionalidades da aplicação.') + '</div>';
        }

        message += '<div class="text-right mt-2">' +
            '<a href="#" class="btn btn-xs btn-success btn-reload">' + this.translate.instant('Atualizar!') + '</a>' +
            '</div></div>';

        this.toastrService.info(
            message,
            this.translate.instant('Nova versão disponível'),
            {
                enableHtml: true,
                closeButton: true,
                tapToDismiss: false,
                disableTimeOut: true,
                positionClass: 'toast-bottom-right',
                toastClass: 'ngx-toastr toastr-reload',
            }
        );
    }

    private checkVersion(url) {
        if (!url) { return; }
        this.http.get(url + '?noLoader=true&t=' + new Date().getTime())
            .subscribe(
                (response: any) => {
                    const hash = response.hash;
                    const hashChanged = this.hasHashChanged(this.currentHash, hash);
                    if (hashChanged && !this.messageDisplayed) {
                        this.messageDisplayed = true;
                        this.showUpdateMessage(false);
                    }
                },
                (err) => {
                    console.warn(err, 'Could not get version');
                }
            );
    }

    private hasHashChanged(currentHash, newHash) {
        if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
            return false;
        }
        return currentHash !== newHash;
    }
}
